import { Alert } from '@mui/material';
import { FC } from 'react';
import { useFormikContext } from 'formik';
import { POST_WITH_ID } from '@brickwise/asset-validation/dist/asset/assetData';

import { useTranslation } from 'react-i18next';

export const AssetFormError: FC = () => {
  const formik = useFormikContext<POST_WITH_ID>();
  const { t } = useTranslation();

  const shouldDisplayError = Object.keys(formik.touched).length > 0 && Object.keys(formik.errors).length > 0;

  if (!shouldDisplayError) return null;

  return (
    <Alert sx={{ marginTop: '24px' }} severity="error">
      {t('dashboard.assets.addedit.error')}
    </Alert>
  );
};
